import React from 'react'
import PropTypes from 'prop-types'
import { kebabCase } from 'lodash'
import { Helmet } from 'react-helmet'
import { graphql, Link } from 'gatsby'
import Layout from '../components/Layout'
import Content, { HTMLContent } from '../components/Content'
import BlogRoll from "../components/BlogRoll";

export const BlogPostTemplate = ({
  id,
  content,
  contentComponent,
  description,
  tags,
  title,
  helmet,
  tableOfContents
}) => {
  const PostContent = contentComponent || Content;

  const $fadeOutDiv = `
    <div style="position: sticky; bottom: -1px; height: 80px; width: 100%;
      background: -webkit-linear-gradient(rgba( 255, 255, 255, 0), rgba(255, 255, 255, 1) );
      background: linear-gradient( rgba(255, 255, 255, 0), rgba(255, 255, 255, 1) )"
      id="sticky-nav-fade-out"
    ></div>
  `;

  const modifiedTableOfContents = tableOfContents + $fadeOutDiv;

  return (
    <section className="section">
      {helmet || ""}
      <div className="container content">
        <div className="columns">
          <div className="column is-2">
            {/* <PostContent className="sticky-nav" content={tableOfContents} /> */}
          </div>
          <div className="column is-6">
            <h1 className="title is-size-2 has-text-weight-bold is-bold-light">
              {title}
            </h1>
            <p>{description}</p>
            <PostContent className="post-content" content={content} />
            {tags && tags.length ? (
              <div style={{ marginTop: `4rem` }}>
                <h4>Tags</h4>
                <ul className="taglist">
                  {tags.map(tag => (
                    <li key={tag + `tag`}>
                      <Link to={`/tags/${kebabCase(tag)}/`}>{tag}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            ) : null}
            <section className="read-more-section">
              <h3 className="product-main-header has-text-centered has-text-complementary">
                Read more
              </h3>
              <BlogRoll postToHide={id} />
            </section>
          </div>
          <div className="column blog-nav-column is-3 is-hidden-mobile">
            <PostContent
              className="sticky-nav stick-nav-fade-out"
              content={modifiedTableOfContents}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

BlogPostTemplate.propTypes = {
  content: PropTypes.node.isRequired,
  contentComponent: PropTypes.func,
  description: PropTypes.string,
  title: PropTypes.string,
  helmet: PropTypes.object
};

const BlogPost = ({ data }) => {
  const { markdownRemark: post } = data;

  return (
    <Layout>
      <BlogPostTemplate
        id={post.id}
        content={post.html}
        contentComponent={HTMLContent}
        description={post.frontmatter.description}
        tableOfContents={post.tableOfContents}
        helmet={
          <Helmet titleTemplate="%s | Blog">
            <title>{`${post.frontmatter.title}`}</title>
            <meta
              name="description"
              content={`${post.frontmatter.description}`}
            />
          </Helmet>
        }
        tags={post.frontmatter.tags}
        title={post.frontmatter.title}
      />
    </Layout>
  );
};

BlogPost.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.object
  })
};

export default BlogPost;

export const pageQuery = graphql`
  query BlogPostByID($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      tableOfContents(maxDepth: 3)
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        title
        description
        tags
        postStatus
      }
    }
  }
`;
